import { render, staticRenderFns } from "./Apartment.vue?vue&type=template&id=5f323f7c&scoped=true"
import script from "./Apartment.vue?vue&type=script&lang=js"
export * from "./Apartment.vue?vue&type=script&lang=js"
import style0 from "./Apartment.vue?vue&type=style&index=0&id=5f323f7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f323f7c",
  null
  
)

export default component.exports